<!-- =========================================================================================
    File Name: Tasks.vue
    Description: Task Application (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <!-- WORKER LIST -->
    <vx-card class="mb-3">
      <div slot="no-body" class="p-1 pl-5">
        <div class="mt-1 flex">
          <div style="width: 100px; margin-top: 10px">Worker Filter:</div>
          <vx-tooltip text="Show all workers" style="width: 40px">
            <vs-avatar
              color="danger"
              text="ALL"
              @click="SelectWorkerID(null)"
              class="selectableFilter2"
              :class="{ selectedFilterItem: workerIDFilter == null }"
            />
          </vx-tooltip>

          <div
            vs-lg="1"
            vs-sm="1"
            vs-xs="2"
            v-for="worker in workerList"
            :key="worker.WorkerID"
          >
            <vx-tooltip :text="worker.WorkerName" style="width: 40px">
              <vs-avatar
                :src="worker.WorkerAvatar"
                @click="SelectWorkerID(worker.WorkerID)"
                class="selectableFilter"
                :class="{
                  selectedFilterItem: workerIDFilter == worker.WorkerID,
                }"
              />
              <!-- </div> -->
            </vx-tooltip>
          </div>
        </div>
      </div>
    </vx-card>

    <!--CLIENT LIST-->
    <vx-card class="mb-3">
      <div slot="no-body" class="p-1 pl-5">
        <div class="mt-1 flex">
          <div style="width: 100px; margin-top: 10px">Client Filter:</div>
          <vx-tooltip text="Show all clients" style="width: 40px">
            <vs-avatar
              color="primary"
              text="ALL"
              @click="SelectClientID(null)"
              class="selectableFilter2"
              :class="{ selectedFilterItem: clientIDFilter == null }"
            />
          </vx-tooltip>

          <div
            vs-lg="1"
            vs-sm="1"
            vs-xs="2"
            v-for="client in projectClientList"
            :key="client.ClientID"
          >
            <vx-tooltip :text="client.ClientName" style="width: 40px">
              <!-- <div> -->
              <vs-avatar
                :src="client.ClientAvatar"
                @click="SelectClientID(client.ClientID)"
                class="selectableFilter"
                :class="{
                  selectedFilterItem: clientIDFilter == client.ClientID,
                }"
              />
              <!-- </div> -->
            </vx-tooltip>
          </div>
        </div>
      </div>
    </vx-card>

    <div
      id="email-app"
      class="
        border border-solid
        d-theme-border-grey-light
        rounded
        relative
        overflow-hidden
      "
    >
      <vs-sidebar
        class="items-no-padding"
        parent="#email-app"
        :click-not-close="clickNotClose"
        :hidden-background="clickNotClose"
        v-model="isProjectsSidebarActive"
      >
        <projects-sidebar
          :clientIDFilter2="clientIDFilter"
          :workerIDFilter2="workerIDFilter"
          @closeSidebar="toggleProjectsSidebar"
          v-on:ChildCreateProject="CreateProject"
        />
      </vs-sidebar>

      <div
        :class="{ 'sidebar-spacer': clickNotClose }"
        class="
          no-scroll-content
          border border-solid
          d-theme-border-grey-light
          border-r-0 border-t-0 border-b-0
        "
      >
        <!-- SEARCH BAR -->
        <div class="flex border d-theme-dark-bg items-right">
          <feather-icon
            v-if="!isProjectsSidebarActive"
            class="md:inline-flex ml-4 mr-4 cursor-pointer"
            icon="MenuIcon"
            @click.stop="toggleProjectsSidebar(true)"
          />
          <div class="my-1 ml-5 flex"></div>
          <div class="float-right p-2 flex" style="margin-left: auto">
            <vs-button
              v-if="isAdmin"
              color="success"
              @click="EditProject"
              size="small"
              icon="edit"
              >Edit</vs-button
            >
            <!-- <vs-button v-if="isAdmin" @click="DeleteProject" size="small" class="ml-2" icon="delete" color="danger">Archive</vs-button> -->
            <vs-button
              @click="ViewInJira()"
              size="small"
              class="ml-2"
              icon="link"
              color="primary"
              >View In Jira</vs-button
            >
            <vs-button
              v-if="isAdmin"
              @click="SyncFromJira()"
              size="small"
              class="ml-2"
              icon="link"
              color="warning"
              >Sync From Jira</vs-button
            >
          </div>
        </div>

        <!-- EMAILS LIST -->
        <component
          ref="scroll"
          :is="scrollbarTag"
          class="email-content-scroll-area"
          :settings="settings"
          :key="$vs.rtl"
        >
          <div class="p-8" v-if="selectedProject != null">
            <!-- <vs-row vs-w="12">
              <vs-col vs-lg="4" vs-sm="12"> -->
                <div>
                  
                  <div class="flex" style="align-items: center;">
                    <div style="min-width: 70px">
                      <vs-avatar
                        :src="selectedProjectClientInfo().ClientAvatar"
                        size="large"
                        class="mr-3"/>
                    </div>
                    <div>
                      <div class="flex" style="align-items: baseline;">
                        <h1 class="mr-4">{{ selectedProject.JiraInfo.name }}</h1>
                        <h3 class="mx-4">{{ selectedProjectClientInfo().ClientName }}</h3>
                        
                        <vs-chip class="ml-2 mr-2">Start Date:
                          {{
                            GetFormattedTime(
                              selectedProject.ITATInfo.ProjectStartDate
                            )
                          }}
                        </vs-chip>
                        <vs-chip class="mx-2"> 
                          {{ Math.round(GetFilteredHours().actualHours * 10) / 10 }}
                          /
                          {{ Math.round(GetFilteredHours().estimatedHours * 10) / 10 }}
                          Hours 
                        </vs-chip>
                        <!-- <vs-chip class="mx-2">
                          ${{ Math.round(GetFilteredBudget().actualBudget * 10) / 10 }}
                          / 
                          ${{ Math.round(GetFilteredBudget().estimatedBudget * 10) / 10 }}
                          Budget
                        </vs-chip> -->
                      </div>
                      <div style="font-style:oblique;">{{ selectedProject.ITATInfo.ProjectDescription }}</div>
                    </div>
                  </div>

                  <div style="padding-left: 70px;" class="mt-8">
                    <div class="flex">
                      <div style="width: 300px;">
                        <label style="position: absolute; margin-top: -13px;">Progress: {{ GetProjectProgress().toFixed(1) }}%</label>
                        <vs-progress :percent="GetProjectProgress()"></vs-progress>
                      </div>
                      <!-- <div style="width: 300px;" class="ml-5">
                        <label style="position: absolute; margin-top: -13px;">Budget: {{ GetProjectBudget().toFixed(1) }}%</label>
                        <vs-progress :percent="GetProjectBudget()"></vs-progress>
                      </div> -->
                    </div>

                  <!-- WORKERS -->
                  <h5 class="mb-2 mt-5">Workers (Assigned in Jira)</h5>

                   <div v-if="GetWorkersInProject().length > 0" class="mt-3">
                      <vs-row vs-w="12">
                        <vs-col
                          vs-lg="2"
                          vs-sm="4"
                          vs-xs="6"
                          v-for="(worker, index) in GetWorkersInProject()"
                          :key="index"
                        >
                          <vx-tooltip
                            :text="worker.Count + ' Tasks'"
                            position="top"
                          >
                            <div class="flex">
                              <div style="min-width: 40px">
                                <vs-avatar
                                  :src="worker.Worker.WorkerAvatar"
                                  badge-color="primary"
                                  :badge="worker.Count"
                                />
                              </div>
                              <div class="mt-3 mr-8" style="font-size:12px;">
                                {{ worker.Worker.WorkerName }}
                              </div>
                            </div>
                          </vx-tooltip>
                        </vs-col>
                      </vs-row>
                    </div>
                    <div v-else>No Workers in Project</div>


                    <!-- PROJECT TASKS FILTER -->
                    <h5 class="mb-2 mt-5">Project Tasks Filter</h5>
                    <vs-row>
                      <vs-col
                        v-for="group in taskGroupList"
                        :key="group.TaskGroup"
                        vs-lg="3"
                        vs-sm="6"
                        vs-xs="12"
                      >
                      <vx-tooltip :text="group.TaskGroup">
                        <vs-checkbox
                          v-model="checkBox1"
                          :vs-value="group.TaskGroup"
                          class="mr-6 mt-2"
                          >{{ group.TaskGroup.substring(0,50) == group.TaskGroup ? group.TaskGroup : group.TaskGroup.substring(0,47) + "..." }}</vs-checkbox
                        >
                      </vx-tooltip>
                      </vs-col>
                    </vs-row>


                  </div>
                </div>
              <!-- </vs-col>
              <vs-col vs-lg="6" vs-sm="12"> -->
                
               <!--</vs-col>
              <vs-col vs-lg="2" vs-sm="12"> -->
              <!-- </vs-col>
            </vs-row> -->
            <div class="mx-8 mb-8 mt-3">
              <!-- <vx-card title="Tasks"> -->
              <div class="mx-10">
                <!-- <vs-button v-if="isAdmin" size="small" icon="add" class="mb-2 mt-3" @click="CreateTask"> Create New Task </vs-button> -->
              </div>
              <vs-table
                v-model="selectedTask"
                class="mx-10"
                max-items="10"
                pagination
                :data="filteredTaskList"
                @selected="HandleSelectedTask"
              >
                <template slot="header"> </template>
                <template slot="thead">
                  <vs-th> Task </vs-th>
                  <vs-th> Jira Worker </vs-th>
                  <vs-th> All Workers </vs-th>
                  <vs-th> Hours </vs-th>
                  <!-- <vs-th> Budget </vs-th> -->
                  <!-- <vs-th> Details </vs-th> -->
                  <!-- <vs-th> Utilization </vs-th> -->
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                    :data="tr"
                  >
                    <vs-td
                      :data="tr.key + ' - ' + tr.TaskGroup + ' - ' + tr.fields.summary"
                    >
                      <span>
                      {{
                        tr.key + ' - ' +
                        tr.TaskGroup +
                        " - " +
                        tr.fields.summary
                      }}
                      </span>
                     
                    </vs-td>

                    <vs-td :data="tr.WorkerName">
                      {{
                        GetWorkerByID(tr.fields.assignee).WorkerName
                      }}
                    </vs-td>

                    <vs-td
                      :data="DisplayNameFromJiraInfo(tr)"
                      style="font-size: 12px;"
                    >
                      {{ DisplayNameFromJiraInfo(tr) }}
                    </vs-td>

                    <vs-td
                      :data="
                        tr.fields.timeoriginalestimate /
                        tr.fields.timespent
                      "
                    >
                      <vs-progress
                        :percent="GetBarPercent(tr)"
                        :color="GetBarColor(GetBarPercent(tr))"
                      ></vs-progress>
                      <span
                        >{{ Math.round(tr.fields.timespent * 10) / 10 }} /
                        {{
                          Math.round(
                            tr.fields.timeoriginalestimate * 10
                          ) / 10
                        }}</span>
                    </vs-td>

                    <!-- <vs-td
                      :data="
                        tr.fields.timeoriginalestimate /
                        tr.ITATInfo.ActualBudget
                      ">
                      <vs-progress
                        :percent="GetBarPercentBudget(tr)"
                        :color="GetBarColor(GetBarPercentBudget(tr))"
                      ></vs-progress>
                      <span
                        >${{
                          Math.round(tr.ITATInfo.ActualBudget * 100) / 100
                        }}
                        / ${{
                          Math.round(tr.ITATInfo.EstimatedBudget * 100) / 100
                        }}</span>
                    </vs-td> -->

                    <!-- <vs-td :data="tr.ITATInfo.DetailsURL">
                      <vs-button
                        size="small"
                        @click="ViewDetails(tr)"
                        icon="link">Details
                      </vs-button>
                    </vs-td> -->
                    <!-- <vs-td>
                      <vs-chip v-if="tr.ITATInfo.Billable" color="success">Billable</vs-chip>
                      <vs-chip v-if="!tr.ITATInfo.Billable && tr.ITATInfo.Productive" color="warning">Productive</vs-chip>
                      <vs-chip v-if="!tr.ITATInfo.Billable && !tr.ITATInfo.Productive" color="danger">Unproductive</vs-chip>
                    </vs-td> -->
                  </vs-tr>
                </template>
              </vs-table>
              <!-- </vx-card> -->
            </div>
          </div>

          <!-- <transition-group name="list-enter-up" class="email__mails" tag="ul" appear>
                    <li class="email__mail-item" v-for="(task, index) in taskList" :key="'task'+task.TaskID" :style="{transitionDelay: (index * 0.1) + 's'}"> 
                        
                        <projects-item :task="task" :currentTask="currentTask.task" v-on:ChildClockIn="ErrorClockIn" />
                    </li>
                </transition-group> -->
        </component>
      </div>
    </div>

    <vs-prompt
      :color="
        projectModal.action == 'edit'
          ? 'success'
          : projectModal.action == 'delete'
          ? 'danger'
          : 'primary'
      "
      :title="projectModal.title"
      @accept="SubmitProject"
      :active.sync="projectModal.active"
      :is-valid="projectModalValid"
    >
      <div class="con-exemple-prompt">
        <vs-alert
          color="danger"
          v-if="projectModal.action == 'delete'"
          class="mb-5"
        >
          Please review the project details before deleting:
        </vs-alert>
        <v-select
          @input="OnChangedClient"
          :options="projectClientList"
          :reduce="(x) => x.ClientID"
          label="ClientName"
          v-model="projectModal.clientID"
          placeholder="Client"
          :class="{ dropdownDisabled: true }"
        />
        <!--{ dropdownDisabled: (projectModal.action=='delete') }-->
        <v-select
          :options="FilteredCategories()"
          :reduce="(x) => x.CategoryID"
          label="CategoryName"
          v-model="projectModal.categoryID"
          placeholder="Category"
          class="mt-2"
          :class="{
            dropdownDisabled:
              categoryDropdownDisabled || projectModal.action == 'delete',
          }"
        />

        <vs-input
          disabled
          label="Project Name"
          v-model="projectModal.projectName"
        ></vs-input>
        <vs-textarea
          :disabled="projectModal.action == 'delete'"
          :class="{ dropdownDisabled: projectModal.action == 'delete' }"
          rows="5"
          v-model="projectModal.projectDescription"
          label="Project Description"
          class="mt-2 timeEntryTextArea"
        ></vs-textarea>
        <div>
          <vs-input-number
            :disabled="projectModal.action == 'delete'"
            :class="{ dropdownDisabled: projectModal.action == 'delete' }"
            min="0"
            label="Priority: "
            v-model="projectModal.priority"
          />
          <!-- <vs-checkbox v-model="projectModal.billable">Billable</vs-checkbox> -->
        </div>

        <div v-if="projectModal.action == 'delete'" class="mt-5">
          <vs-alert color="danger" v-if="projectModal.action == 'delete'">
            Type "DELETE" to delete the project:
          </vs-alert>
          <vs-input
            color="danger"
            v-model="projectModal.deleteInput"
          ></vs-input>
        </div>
      </div>
    </vs-prompt>
    <vs-prompt
      :color="
        taskModal.action == 'edit'
          ? 'success'
          : taskModal.action == 'delete'
          ? 'danger'
          : 'primary'
      "
      :title="taskModal.title"
      @accept="SubmitTask"
      :active.sync="taskModal.active"
      :is-valid="taskModalValid"
    >
      <div class="con-exemple-prompt">
        <vs-alert
          color="danger"
          v-if="taskModal.action == 'delete'"
          class="mb-5"
        >
          Please review the task details before deleting:
        </vs-alert>
        <v-select
          disabled
          :options="workerList"
          :reduce="(x) => x.WorkerID"
          label="WorkerName"
          v-model="taskModal.workerID"
          placeholder="Worker"
          :class="{ dropdownDisabled: taskModal.action == 'delete' }"
        />
        <!-- <v-select class="mt-1" :options="taskStatusLookups" :reduce="x => x.LookupID" label="LookupValue" v-model="taskModal.statusID" placeholder="Undefined"/> -->
        <vs-input
          disabled
          label="Task Group"
          v-model="taskModal.taskGroup"
        ></vs-input>
        <!-- :disabled="taskModal.action=='delete'"-->
        <vs-input
          disabled
          label="Task Name"
          v-model="taskModal.taskName"
        ></vs-input>
        <!-- :disabled="taskModal.action=='delete'"-->
        <vs-textarea
          disabled
          :class="{ dropdownDisabled: taskModal.action == 'delete' }"
          rows="5"
          v-model="taskModal.taskDetails"
          label="Task Description"
          class="mt-2 timeEntryTextArea"
        ></vs-textarea>
        <!-- <vs-input :disabled="taskModal.action=='delete'" type="number" label="Estimated Hours" v-model="taskModal.estimatedHours"></vs-input> -->
        <vs-input
          :disabled="taskModal.action == 'delete'"
          type="number"
          label="Estimated Budget"
          v-model="taskModal.estimatedBudget"
        ></vs-input>
        <!-- <vs-input :disabled="taskModal.action=='delete'" label="Details URL" v-model="taskModal.detailsURL"></vs-input> -->

        <div>
          <vs-input-number
            :disabled="taskModal.action == 'delete'"
            :class="{ dropdownDisabled: taskModal.action == 'delete' }"
            min="0"
            label="Priority: "
            v-model="taskModal.priority"
          />
        </div>

        <!-- <vs-checkbox v-model="taskModal.billable">Billable</vs-checkbox>
        <vs-checkbox v-model="taskModal.productive" v-if="!taskModal.billable" class="mt-2">Productive</vs-checkbox> -->


        <div v-if="taskModal.action == 'delete'" class="mt-5">
          <vs-alert color="danger" v-if="taskModal.action == 'delete'">
            Type "DELETE" to delete the task:
          </vs-alert>
          <vs-input color="danger" v-model="taskModal.deleteInput"></vs-input>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import ProjectsSidebar from "./ProjectsWorkerSidebar.vue";
import ProjectsItem from "./ProjectsWorkerItem.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueApexCharts from "vue-apexcharts";
import Dialogs from "../../components/vuesax/dialogs/Dialogs.vue";
import vSelect from "vue-select";
import moment from "moment";
import VxTooltip from "../../../layouts/components/vx-tooltip/VxTooltip.vue";

export default {
  data() {
    return {
      clientIDFilter: null,
      workerIDFilter: null,
      checkBox1: [],
      selectedTask: [],
      projectModal: {
        title: "Create New Project",
        active: false,
        projectName: "",
        projectDescription: "",
        clientID: null,
        categoryID: null,
        priority: 0,
        action: "create",
        deleteInput: "",
        billable: false,
      },
      taskModal: {
        title: "Create New Task",
        active: false,
        taskGroup: "",
        taskName: "",
        taskDetails: "",
        priority: 0,
        workerID: null,
        estimatedHours: 0,
        estimatedBudget: 0,
        // detailsURL: null,
        action: "create",
        deleteInput: "",
        statusID: 0,
        // billable: false,
        productive: false
      },
      selectedMails: [],
      isSidebarActive: false,
      showThread: false,
      clickNotClose: true,
      isProjectsSidebarActive: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
      currentTask: {
        active: true,
        task: {},
      },
      clockOutPromptData: {
        active: false,
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i", //'d-m-Y H:i K'
      },
    };
  },
  watch: {
    isSidebarActive(value) {
      if (!value) this.showThread = false;
    },
    windowWidth() {
      this.setSidebarWidth();
    },
    selectedProjectID(val) {
      this.checkBox1 = JSON.parse(JSON.stringify(this.taskGroupListLabels));
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters.GetIsAdmin;
    },
    taskStatusLookups() {
      return this.$store.getters.GetTaskStatusLookups;
    },
    selectedProjectID() {
      return this.$store.getters.GetSelectedProjectID
    },
    taskList() {
      const t = this.$store.getters.GetTaskList; //.filter(x => x.JiraInfo.fields.project.id === this.selectedProjectID)
      const groups = [];
      for (let i = 0; i < t.length; i++) {
        const group = t[i].TaskGroup;
        if (groups.indexOf(group) === -1) {
          groups.push(group);
        }
      }
      this.checkBox1 = groups;

      return t;
    },
    projectTaskList() {
      return this.taskList.filter(
        (x) => x.fields.project.id == this.selectedProjectID
      );
    },
    filteredTaskList() {
      return this.taskList
        .filter((x) => this.checkBox1.indexOf(x.TaskGroup) !== -1)
        .filter((x) => x.fields.project.id == this.selectedProjectID);
    },
    sowSelectedTasks() {
      return this.$store.getters.GetSOWSelectedTasks
    },
    taskGroupList() {
      const groups = []
      // const tasks = this.sowSelectedTasks == null ? this.projectTaskList : this.sowSelectedTasks
      const tasks = this.projectTaskList
      for (let i = 0; i < tasks.length; i++) {
        const group = tasks[i].TaskGroup;
        if (groups.find(x => x.TaskGroup == group) == null) {
          groups.push(tasks[i]);
        }
      }
      return groups;
    },
    taskGroupListLabels() {
      const groups = [];
      const tasks = this.sowSelectedTasks == null ? this.projectTaskList : this.sowSelectedTasks
      console.log('computing labels', this.sowSelectedTasks)
      for (let i = 0; i < tasks.length; i++) {
        const group = tasks[i].TaskGroup;
        if (groups.indexOf(group) === -1) {
          groups.push(group);
        }
      }
      return groups;
    },
    projectModalValid() {
      if (this.projectModal.action === "delete") {
        if (this.projectModal.deleteInput !== "DELETE") return false;
      }
      if (this.projectModal.action === "create") {
        if (this.projectModal.projectName === "") return false;
        if (this.projectModal.projectDescription === "") return false;
        if (this.projectModal.clientID == null) return false;
      }
      return true;
    },
    taskModalValid() {
      if (this.taskModal.action === "delete") {
        if (this.taskModal.deleteInput !== "DELETE") return false;
      }
      if (this.taskModal.action === "create") {
        if (this.taskModal.taskGroup === "") return false;
        if (this.taskModal.taskName === "") return false;
        if (this.taskModal.taskDetails === "") return false;
        if (this.taskModal.estimatedTime === 0) return false;
        if (this.taskModal.workerID == null || this.taskModal.workerID === "")
          return false;
      }
      return true;
    },
    categoryDropdownDisabled() {
      if (this.projectModal.clientID == null || this.projectModal === "")
        return true;
      return false;
    },
    categoryList() {
      return this.$store.getters.GetCategoryList;
    },
    workerList() {
      return this.$store.getters.GetSyncedWorkerList;
    },
    clientList() {
      return this.$store.getters.GetClientList;
    },
    selectedProject() {
      const proj = this.projectList.find(
        (x) => x.JiraInfo.id === this.selectedProjectID
      );
      console.log(proj);
      return proj;
    },
    validEntry() {
      return true;
    },
    projectClientList() {
      const clients = [];
      const clientIDS = [];
      for (let i = 0; i < this.projectList.length; i++) {
        const client = this.GetClientFromID(
          this.projectList[i].ITATInfo.ClientID
        );
        if (client == null) continue;

        if (clientIDS.indexOf(client.ClientID) === -1) {
          const obj = {
            ClientID: client.ClientID,
            ClientAvatar: client.ClientAvatar,
            ClientName: client.ClientName,
          };
          console.log(obj);
          clients.push(obj);
          clientIDS.push(client.ClientID);
        }
      }
      return clients;
    },
    projectList() {
      const newList = JSON.parse(
        JSON.stringify(this.$store.getters.GetProjectList)
      );
      return newList.sort((a, b) =>
        a.ITATInfo.ProjectPriority < b.ITATInfo.ProjectPriority ? 1 : -1
      );
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  methods: {
    DisplayNameFromJiraInfo(jiraInfo) {
      if (jiraInfo.assignee == null) {
        return '-'
      }
      return jiraInfo.assignee.displayName
    },
    WorkerStringFromArray(val) {
      var out = "";
      for (var i = 0; i < val.length; i++) {
        var atlassianID = val[i];
        if (atlassianID != null) {
          out += this.GetWorkerFromJiraID(atlassianID).ITATInfo.WorkerName + (i < val.length - 1 ? ", " : "");
        }
      }
      return out;
    },
    SyncFromJira() {},
    ViewInJira() {
      window.open(
        `https://${this.$store.getters.GetJiraDomain}.atlassian.net/browse/${this.selectedProject.JiraInfo.key}`,
        "_blank"
      )
    },
    GetWorkerByID(assignee) {
      const worker = assignee != null
        ? this.workerList.find((x) => x.WorkerID === assignee)
        : null;
      if (worker == null) return { WorkerName: "No Worker" };
      return { WorkerName: worker.WorkerName };
    },
    selectedProjectClientInfo() {
      const info = {
        ClientAvatar: null,
        ClientName: "",
      };
      let c = this.GetClientFromID(this.selectedProject.ITATInfo.ClientID);
      if (c != null) {
        info.ClientAvatar = c.ClientAvatar;
        info.ClientName = c.ClientName;
      }
      return info;
    },
    GetFilteredHours() {
      const hours = {
        estimatedHours: 0,
        actualHours: 0,
      };
      for (let i = 0; i < this.filteredTaskList.length; i++) {
        const task = this.filteredTaskList[i];
        hours.estimatedHours += task.fields.timeoriginalestimate;
        hours.actualHours += Math.min(
          task.fields.timespent,
          task.fields.timeoriginalestimate
        );
      }
      return hours;
    },
    // GetFilteredBudget() {
    //   const budget = {
    //     estimatedBudget: 0,
    //     actualBudget: 0,
    //   };
    //   for (let i = 0; i < this.filteredTaskList.length; i++) {
    //     const task = this.filteredTaskList[i];
    //     budget.estimatedBudget += task.ITATInfo.EstimatedBudget;
    //     budget.actualBudget += Math.min(
    //       task.ITATInfo.ActualBudget,
    //       task.ITATInfo.EstimatedBudget
    //     );
    //   }
    //   return budget;
    // },
    GetFilteredHoursRatio() {
      const hours = this.GetFilteredHours();
      let result = hours.actualHours / hours.estimatedHours;
      if (hours.estimatedHours === 0) result = 1;
      return result;
    },
    // GetFilteredBudgetRatio() {
    //   const budget = this.GetFilteredBudget();
    //   let result = budget.actualBudget / budget.estimatedBudget;
    //   if (budget.estimatedBudget === 0) result = 1;
    //   return result;
    // },
    // GetLastPriority() {
    //   if (this.filteredTaskList.length === 0) {
    //     return -1;
    //   }
    //   return this.filteredTaskList[this.filteredTaskList.length - 1].ITATInfo
    //     .TaskPriority;
    // },
    SelectClientID(id) {
      this.clientIDFilter = id;
    },
    GetFormattedTime(time) {
      return moment(time, "YYYY-MM-DD hh:mm A").format("MM/DD/YY");
    },
    ViewDetails(t) {
      window.open(
        `https://${this.$store.getters.GetJiraDomain}.atlassian.net/browse/${t.key}`,
        "_blank"
      );
    },
    SubmitProject() {},
    SubmitTask() {
      // if (this.taskModal.action === 'create') {
      //   var data = {
      //     ProjectID: this.selectedProject.ITATInfo.ProjectID,
      //     TaskGroup: this.taskModal.taskGroup,
      //     TaskName: this.taskModal.taskName,
      //     TaskDetails: this.taskModal.taskDetails,
      //     TaskPriority: this.taskModal.priority,
      //     WorkerID: this.taskModal.workerID,
      //     EstimatedHours: this.taskModal.estimatedHours,
      //     EstimatedBudget: this.taskModal.estimatedBudget,
      //     DetailsURL: this.taskModal.detailsURL
      //   }
      //   this.$store.dispatch('ActionPostTask', data)
      // }

      if (this.taskModal.action === "edit") {
        if (this.taskModal.statusID == null) this.taskModal.statusID = 0;
        var data = {
          TaskID: this.selectedTask.ITATInfo.TaskID,
          // ProjectID: this.selectedProject.ITATInfo.ProjectID,
          // TaskGroup: this.taskModal.taskGroup,
          // TaskName: this.taskModal.taskName,
          // TaskDetails: this.taskModal.taskDetails,
          // TaskPriority: this.taskModal.priority,
          // WorkerID: this.taskModal.workerID,
          EstimatedHours: Number(this.taskModal.estimatedHours),
          EstimatedBudget: Number(this.taskModal.estimatedBudget),
          // DetailsURL: this.taskModal.detailsURL,
          // Billable: this.taskModal.billable,
          // Productive: this.taskModal.productive
          // StatusID: this.taskModal.statusID
        };
        console.log(data);
        this.$store.dispatch("ActionPutTask", data);
      }

      if (this.taskModal.action === "delete") {}
    },
    OnChangedClient() {
      if (
        this.projectModal.clientID === "" ||
        this.projectModal.clientID == null
      ) {
        this.projectModal.categoryID = null;
      }
    },
    FilteredCategories() {
      if (this.projectModal.clientID == null) return [];
      if (this.projectModal.clientID === "") return [];

      return this.categoryList.filter(
        (x) => x.ClientID === this.projectModal.clientID
      );
    },
    CreateProject() {
      console.log("Create project");
      this.projectModal.title = "Create New Project";
      this.projectModal.action = "create";
      this.projectModal.active = true;
    },
    CreateTask() {
      console.log("Create task");
      this.taskModal.title = "Create New Task";
      this.taskModal.action = "create";
      this.taskModal.active = true;
      this.taskModal.workerID = null;
      this.taskModal.taskGroup = "";
      this.taskModal.taskName = "";
      this.taskModal.taskDetails = null;
      this.taskModal.estimatedHours = 2;
      // this.taskModal.detailsURL = "";
      // this.taskModal.priority = this.GetLastPriority() + 1;
      this.taskModal.statusID = 1;
    },
    GetTaskContent(task) {
      console.log(task);
      if (task.fields.description == null) return "";

      return task.fields.description.content.reduce(function (
        total,
        item
      ) {
        if (item.type === "paragraph") {
          let add = "";
          for (let i = 0; i < item.content.length; i++) {
            if (item.content[i].type === "text") {
              add += item.content[i].text;
            }
          }
          return total + add;
        } else {
          return total;
        }
      },
      "");
    },
    HandleSelectedTask(sel) {
      if (this.isAdmin === false) {
        this.$vs.notify({
          title: "Unauthorized",
          text: "You must be an administrator to edit tasks!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
        console.log("You must be an admin");
        return;
      }
      let workerID = null;
      if (sel.fields.assignee != null) {
        workerID = this.workerList.find(
          (x) => x.JiraInfo.accountId === sel.fields.assignee.accountId
        ).ITATInfo.WorkerID;
      }
      this.taskModal.title = "Edit Task";
      this.taskModal.action = "edit";
      this.taskModal.active = true;
      this.taskModal.workerID = workerID;
      this.taskModal.taskGroup = sel.TaskGroup;
      this.taskModal.taskName = sel.fields.summary;
      this.taskModal.taskDetails = this.GetTaskContent(sel);
      this.taskModal.estimatedHours = sel.fields.timeoriginalestimate;
      this.taskModal.estimatedBudget = sel.fields.timespent;

      // this.taskModal.detailsURL = sel.DetailsURL;
      // this.taskModal.priority = sel.TaskPriority;
      this.taskModal.statusID = sel.StatusID;
      // this.taskModal.billable = sel.ITATInfo.Billable;
      // this.taskModal.productive = sel.ITATInfo.Productive;

    },
    EditProject() {
      console.log("Edit Project");
      this.projectModal.title = "Edit Project";
      this.projectModal.action = "edit";
      this.projectModal.active = true;
      this.projectModal.billable = this.selectedProject.ITATInfo.Billable
      this.projectModal.clientID = this.selectedProject.ITATInfo.ClientID;
      this.projectModal.categoryID = this.selectedProject.ITATInfo.CategoryID;
      this.projectModal.projectName = this.selectedProject.JiraInfo.name;
      this.projectModal.projectDescription =
        this.selectedProject.ITATInfo.ProjectDescription;
      this.projectModal.priority =
        this.selectedProject.ITATInfo.ProjectPriority;
    },
    DeleteProject() {
      console.log("Delete Project");
      this.projectModal.title = "Delete Project";
      this.projectModal.action = "delete";
      this.projectModal.active = true;
      this.projectModal.clientID = this.selectedProject.ITATInfo.ClientID;
      this.projectModal.categoryID = this.selectedProject.ITATInfo.CategoryID;
      this.projectModal.projectName = this.selectedProject.ITATInfo.ProjectName;
      this.projectModal.projectDescription =
        this.selectedProject.ITATInfo.ProjectDescription;
      this.projectModal.priority =
        this.selectedProject.ITATInfo.ProjectPriority;
      this.projectModal.deleteInput = "";
    },
    GetProjectProgress(){
      return this.Clamp100(this.GetFilteredHoursRatio() * 100)
    },
    // GetProjectBudget(){
    //   return this.Clamp100(this.GetFilteredBudgetRatio() * 100)
    // },
    GetWorkersInProject() {
      const workerNames = [];
      const workers = [];
      for (let i = 0; i < this.projectTaskList.length; i++) {
        if (this.projectTaskList[i].fields.assignee != null) {
          const index = workerNames.indexOf(
            this.projectTaskList[i].fields.assignee.displayName
          );
          if (index === -1) {
            workerNames.push(
              this.projectTaskList[i].fields.assignee.displayName
            );
            workers.push({
              Worker: this.GetWorkerFromJiraID(
                this.projectTaskList[i].fields.assignee.accountId
              ),
              Count: 1,
            });
          } else {
            workers[index].Count++;
          }
        }
      }
      workers.sort((a, b) => (a.Count < b.Count ? 1 : -1));
      return workers;
    },
    GetWorkerFromJiraID(jiraID) {
      return { WorkerName: "Unset Worker", WorkerAvatar: null };
    },
    GetWorkerFromID(workerID) {
      return this.workerList.find((x) => x.WorkerID === workerID) || null;
    },
    GetClientFromID(clientID) {
      if (this.clientList == null) return null;
      return this.clientList.find((x) => x.ClientID === clientID) || null;
    },
    Clamp100(input) {
      if (input > 100) return 100;

      return input;
    },
    GetBarPercent(task) {
      if (task == null) return 0;
      let t = task.fields.timeoriginalestimate;
      if (t == 0) t = 0.001;
      let r = (task.fields.timespent / t) * 100;
      r = Math.round(r * 10) / 10;
      return r;
    },
    // GetBarPercentBudget(task) {
    //   if (task == null) return 0;
    //   let t = task.ITATInfo.EstimatedBudget;
    //   if (t == 0) t = 0.001;
    //   let r = (task.ITATInfo.ActualBudget / t) * 100;
    //   r = Math.round(r * 10) / 10;
    //   return r;
    // },
    GetBarColor(percent) {
      if (percent <= 80) {
        return "success";
      } else if (percent <= 100) {
        return "warning";
      }
      return "danger";
    },
    SelectWorkerID(workerID) {
      console.log(workerID);
      this.workerIDFilter = workerID;
    },

    closTaskViewSidebar() {
      this.isSidebarActive = false;
    },
    setSidebarWidth() {
      if (this.windowWidth < 1300) {
        this.isProjectsSidebarActive = this.clickNotClose = false;
      } else {
        this.isProjectsSidebarActive = this.clickNotClose = true;
      }
    },
    toggleProjectsSidebar(value = false) {
      if (!value) {
        this.closTaskViewSidebar();
        if (this.clickNotClose) {
          return;
        }
      }
      this.isProjectsSidebarActive = value;
    },
    ErrorClockIn() {
      this.$vs.notify({
        color: "danger",
        title: "Error",
        text: "You must clock out before clocking in!",
      });
    },
  },
  components: {
    ProjectsItem,
    ProjectsSidebar,
    VuePerfectScrollbar,
    flatPickr,
    VueApexCharts,
    "v-select": vSelect,
    VxTooltip,
  },
  created() {},
  Dialogs() {
    this.setSidebarWidth();
  },
  beforeDestroy() {},
  mounted() {
    this.checkBox1 = JSON.parse(JSON.stringify(this.taskGroupListLabels))
    this.$store.commit('SetSOWSelectedTasks', null)

  },
};
</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/tasks.scss";
</style>

<style lang="css">
.selectableFilter,
.selectableFilter2 {
  transition: all 0.2s ease-in-out;
  box-shadow: 0px 0 8px 3px transparent;
}
.selectableFilter.selectedFilterItem {
  transform: translateY(-5px);
  box-shadow: 0px 0 8px 3px #7367f0;
}
.selectableFilter2.selectedFilterItem {
  box-shadow: 0px 0 8px 3px #7367f0;
}
</style>